// ----------------------------------------------------------------------

const roots = {
  auth: '/auth',
  bundle: '/bundle',
  b2b: '/b2b',
  customer: '/customer',
  subscription: '/subscription',
  vendorActivations: '/vendor-activations',
  setantaActivations: '/setanta-activations',
  cancellationSchedule: '/cancellation-schedule',
  downgradeSchedule: '/downgrade-schedule',
  customerBlacklist: '/customer-blacklist',
  changeLog: '/change-log',
  netflixInitiatedChanges: '/netflix-initiated-changes',
  internalUser: '/internal-user',
  role: '/role',
  apiCertification: '/api-certification',
};

// ----------------------------------------------------------------------

export const paths = {
  auth: {
    login: `${roots.auth}/login`,
  },
  customer: {
    root: `${roots.customer}`,
  },
  bundle: {
    root: `${roots.bundle}`,
  },
  b2b: {
    root: `${roots.b2b}`,
  },
  changeLog: {
    root: `${roots.changeLog}`,
  },
  subscription: {
    root: `${roots.subscription}`,
  },
  vendorActivations: {
    root: `${roots.vendorActivations}`,
  },
  setantaActivations: {
    root: `${roots.setantaActivations}`,
  },
  cancellationSchedule: {
    root: `${roots.cancellationSchedule}`,
  },
  downgradeSchedule: {
    root: `${roots.downgradeSchedule}`,
  },
  customerBlacklist: {
    root: `${roots.customerBlacklist}`,
  },
  netflixInitiatedChanges: {
    root: `${roots.netflixInitiatedChanges}`
  },

  internalUser: {
    root: `${roots.internalUser}`,
  },
  role: {
    root: `${roots.role}`,
  },

  apiCertification: {
    root: `${roots.apiCertification}`,
  },

  error: {
    tokenExpired: '/token-expired',
  },
};
